import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SparePartsPricingForm from '../../../../components/forms/SparePartsPricingForm/SparePartsPricingForm';
import { toast } from 'react-toastify';
import { Container, Row, Col } from 'react-bootstrap';
import axiosInstance from '../../../../utils/axiosConfig';

const EditSparePartsPricing = () => {
    const { id } = useParams();
    const [initialData, setInitialData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSparePart = async () => {
            try {
                const response = await axiosInstance.get(`/spare-parts/${id}`);
                const data = response.data.data || response.data;
                setInitialData(data);
            } catch (error) {
                console.error('Error fetching spare part:', error);
                toast.error('Failed to load spare part data');
            } finally {
                setLoading(false);
            }
        };

        fetchSparePart();
    }, [id]);

    if (loading) {
        return (
            <Container fluid>
                <div className="mt-5 text-center">Loading...</div>
            </Container>
        );
    }

    return (
        <Container fluid>
            <div className="edit-spare-parts-pricing mt-5 mb-5">
                <h3>Edit Spare Parts Pricing</h3>
            </div>
            <Row>
                <Col md={4}>
                    <h5>Edit Spare Parts Pricing Details</h5>
                    <p>Update the spare part pricing information below.</p>
                </Col>
                <Col md={8}>
                    <SparePartsPricingForm initialData={initialData} isEdit />
                </Col>
            </Row>
        </Container>
    );
};

export default EditSparePartsPricing;
